import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import $ from 'dom7';
import Base from '../js/base.js';
import Utils from '../js/utils.js';
export default (function ($prop, ctx) {
  var currentPopup = null;
  var id_emp = Utils.str2Num(ctx.$f7route.params.id);
  var name = ctx.$f7route.params.name;
  var month = ctx.$f7route.params.month;
  var rows = Base.initdata.review_criteria;
  var scoreOptions = Base.initdata.review_scoring;

  var rating = function rating(idCriteria) {
    var content = scoreOptions.map(function (s) {
      return "<a class=\"button rating-button text-color-".concat(s.color, "\" data-color=\"").concat(s.color, "\" data-score=\"").concat(s.score, "\">").concat(s.name, "</a>");
    }).join('');
    Base.app.dialog.create({
      content: content,
      closeByBackdropClick: true,
      on: {
        open: function open(dialog) {
          $(dialog.el).find('.rating-button').click(function () {
            var score = Utils.str2Num($(this).data('score'));
            var label = $(this).text();
            var color = $(this).data('color');
            var $td = $('.scoring-table').find("td[data-id=\"".concat(idCriteria, "\"]"));
            $td.attr('data-score', score);
            $td.html("<span class=\"text-color-".concat(color, "\">").concat(label, "</span>"));
            dialog.close();
          });
        }
      }
    }).open();
  };

  var confirmSubmit = function confirmSubmit() {
    var submit = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var data, comment, submitData, rs;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = [];
                $('.scoring-table').find("td.scoring-row").each(function () {
                  var score = $(this).data('score');
                  var id = $(this).data('id');

                  if (score !== '') {
                    score = Utils.str2Num(score);
                    data.push({
                      id: id,
                      score: score
                    });
                  }
                });

                if (!(data.length < 8)) {
                  _context.next = 5;
                  break;
                }

                Base.app.dialog.alert('Bạn cần đánh giá TẤT CẢ các tiêu chí');
                return _context.abrupt("return", false);

              case 5:
                comment = $('.other-review-comment').val();
                submitData = {
                  id_emp: id_emp,
                  month: month,
                  comment: comment,
                  data: data
                };
                _context.next = 9;
                return Base.api('Review', 'submitRating', submitData);

              case 9:
                rs = _context.sent;
                currentPopup.close();
                Base.app.emit('afterRated', submitData);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function submit() {
        return _ref.apply(this, arguments);
      };
    }();

    Base.app.dialog.confirm('Bạn đã chắc chắn với đánh giá của mình? Bạn sẽ không được đánh giá lại sau khi Xác Nhận', submit);
  };

  ctx.$on('popup:open', function () {
    $('.scoring-table a.rating-button').click(function () {
      rating($(this).data('id'));
    });
    currentPopup = Base.app.popup.create({
      el: '.cross-review-popup'
    });
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="popup cross-review-popup">
    <div class="view">
      <div class="page">
        <div class="navbar">
          <div class="navbar-bg"></div>
          <div class="navbar-inner">
            <div class="title">Nhận xét và Đánh giá</div>
            <div class="right">
              <a href="#" class="link popup-close"><i class="icon f7-icons">multiply</i></a>
            </div>
          </div>
        </div>
        <div class="page-content">
          <div class="block">
            <div>Bạn đang đánh giá ${name}:</div>
            <div style="font-size: smaller; color: rgb(206, 206, 206);">Hãy chọn các thang điểm theo các tiêu chí dưới đây và ấn Xác nhận. Sau khi bạn Xác nhận, bạn sẽ KHÔNG được đánh giá lại. Vì vậy hãy đánh giá thật khách quan.</div>
          </div>
          
          <div class="data-table scoring-table no-margin">
            <table>
              <thead>
                <tr>
                  <th class="label-cell">Tiêu chí</th>
                  <th class="numeric-cell"></th>
                  <th class="numeric-cell">Đánh giá</th>
                </tr>
              </thead>
              <tbody>
                ${rows.map(row=>$h`
                  <tr>
                    <td class="label-cell">${row.name}</td>
                    <td class="numeric-cell scoring-row" data-id="${row.id}" data-score="" style="white-space: nowrap;text-transform: uppercase; font-size: smaller;">-</td>
                    <td class="numeric-cell"><a class="rating-button" data-id="${row.id}"><i class="icon f7-icons">square_pencil</i></a></td>
                  </tr>
                `)}
              </tbody>
            </table>
          </div>
          <div>
            <textarea name="comment" class="other-review-comment" placeholder="Góp ý khác (nếu có)"></textarea>
          </div>
          <div class="block text-align-center">
            <a class="button submit-button" @click="${confirmSubmit}">Xác nhận</a>
          </div>
        </div>
      </div>
    </div>
  </div>
`
    }
    ;
});